<div *ngIf="data">
<div class="row">
    <div class="row">
        <div class="col-md-3">Qualifier</div>
        <div class="col-md-6"> {{data.qualifier}}</div>
    </div>
    <div class="row">
        <div class="col-md-3">Begin Date</div>
        <div class="col-md-6"> {{data.beginDate}}</div>
    </div>
    <div class="row">
        <div class="col-md-3">End Date</div>
        <div class="col-md-6"> {{data.endDate}}</div>
    </div>
    <div class="row">
        <div class="col-md-3">Description</div>
        <div class="col-md-6"> {{data.description}}</div>
    </div>
</div>
</div>